import { FEATURES_CONFIG } from "../../featuresConfig";

/**
 * holdAndWinPace — the speed a Hold & Win respin (and its collections) runs
 * at (2026-10-23: the client wants turbo and super turbo in Hold & Win).
 *
 * Set ONCE as a respin leaves, and as the End Collector starts
 * (HoldAndWinControlContext), from the player's speed at that moment — a
 * press of the speed button mid-respin applies from the next one. Everything
 * the respin runs reads it from here: the cells' spin (HoldAndWinCellController),
 * the chests (chestCollection), the scarabs (scarabReveal) and the End
 * Collector (endCollector).
 *
 *   auto / quick  FEATURES_CONFIG.HOLD_AND_WIN_SPIN as it is
 *   turbo         HOLD_AND_WIN_SPIN.SPEEDS.TURBO over it: a quick spin and
 *                 drop; collections one by one at COLLECT_TIME_SCALE
 *   super turbo   HOLD_AND_WIN_SPIN.SPEEDS.SUPER_TURBO over it: every cell
 *                 drops at once; collections always skipped (COLLECT_SKIPPED)
 */

let currentSpeed = "auto";
let currentConfig = null;

const speedKey = (speed) => (speed === "turbo" || speed === "super_turbo" ? speed.toUpperCase() : null);

/** The respin's speed — "auto" | "quick" | "turbo" | "super_turbo". */
export const setHoldAndWinPace = (speed) => {
  const next = speed || "auto";
  if (next === currentSpeed && currentConfig) return;
  currentSpeed = next;
  currentConfig = null;
};

export const getHoldAndWinPaceSpeed = () => currentSpeed;

/** HOLD_AND_WIN_SPIN with this speed's overrides on top. */
export const holdAndWinSpinConfig = () => {
  if (currentConfig) return currentConfig;
  const base = FEATURES_CONFIG.HOLD_AND_WIN_SPIN || {};
  const key = speedKey(currentSpeed);
  currentConfig = key ? { ...base, ...(base.SPEEDS?.[key] || {}) } : base;
  return currentConfig;
};

/** The collections' time, x this (1 = as authored). */
export const collectTimeScale = () => holdAndWinSpinConfig().COLLECT_TIME_SCALE ?? 1;

/** Super turbo: every collection runs as if the player had pressed skip. */
export const collectAlwaysSkipped = () => !!holdAndWinSpinConfig().COLLECT_SKIPPED;

/** `ms` at this pace. */
export const paced = (ms) => ms * collectTimeScale();

/**
 * Turbo: the gap between one collection trail LEAVING and the next — they no
 * longer wait for each other to arrive (2026-10-23). null = one at a time,
 * each after the last has landed (normal). Trails always fly at their own
 * speed; only the gap changes.
 */
export const trailGapMs = () => holdAndWinSpinConfig().TRAIL_GAP_MS ?? null;
